webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('StyleEditor', {
    ref: "styleEditor",
    attrs: {
      "code": _vm.currentStyle
    }
  }), _vm._v(" "), _c('ResumeEditor', {
    ref: "resumeEditor",
    attrs: {
      "markdown": _vm.currentMarkdown,
      "enableHtml": _vm.enableHtml
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  "data-v-164e6a7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  "data-v-0f504a34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  "data-v-6e2560d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  "data-v-1fa01a43",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_reset_css__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    StyleEditor: __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default.a,
    ResumeEditor: __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default.a
  },
  data: function data() {
    return {
      interval: 1,
      currentStyle: "",
      enableHtml: false,
      fullStyle: ["/*\n* Inspired by http://strml.net/\n* \u5927\u5BB6\u597D\uFF0C\u6211\u662F\u8001\u59DA\n* \u6BCF\u5929\u90FD\u6709\u5F88\u591A\u4EBA\u5728\u6C42\u804C\u7684\u8DEF\u4E0A\uFF0C\u5728\u7EBF\u7B80\u5386\u5FC5\u4E0D\u53EF\u5C11\u3002\n* \u8FD9\u91CC\u8DDF\u4E2A\u98CE\uFF0C\u6211\u4E5F\u6765\u5199\u4E00\u4EFD\u7B80\u5386\uFF01\n*/\n\n/* \u9996\u5148\u7ED9\u6240\u6709\u5143\u7D20\u52A0\u4E0A\u8FC7\u6E21\u6548\u679C */\n* {\n  transition: all .1s;\n}\n\n/* \u8BBE\u7F6E\u80CC\u666F\u989C\u8272 */\nhtml {\n  color: rgb(222,222,222); background: rgb(0,43,54);\n}\n\n/* \u8BBE\u7F6E\u8FB9\u6846 */\n.styleEditor {\n  padding: .2em;\n  border: 1px solid;\n  margin: .2em;\n  overflow: auto;\n  width: 45vw; height: 100vh;\n  /* background: rgb(20,20,20); */\n}\n\n/* \u4EE3\u7801\u9AD8\u4EAE */\n.token.selector{ color: rgb(133,153,0); }\n.token.property{ color: rgb(187,137,0); }\n.token.punctuation{ color: yellow; }\n.token.function{ color: rgb(42,161,152); }\n\n/* \u52A03D\u6548\u679C */\nhtml{\n  perspective: 1000px;\n}\n.styleEditor {\n  position: fixed; left: 0; top: 0;\n  -webkit-transition: none;\n  transition: none;\n  -webkit-transform: rotateY(10deg) translateZ(-100px) ;\n          transform: rotateY(10deg) translateZ(-100px) ;\n}\n\n/* \u51C6\u5907\u4E00\u4E2A\u7F16\u8F91\u5668 */\n.resumeEditor{\n  position: fixed; right: 0; top: 0;\n  padding: .5em;  margin: .5em;\n  width: 52vw; height: 95vh;\n  border: 1px solid white;\n  /* background: rgb(219, 215, 214); */\n  \n  overflow: auto;\n}\n\n/* \u73B0\u5728\uFF0C\u5F00\u59CB\u5199\u7B80\u5386 */\n", "\n/*\u5C06Markdown\u683C\u5F0F\u7FFB\u8BD1\u6210HTML\n *\u518D\u5BF9HTML\u52A0\u70B9\u6837\u5F0F\n*/\n.resumeEditor{\n  padding: 1em;\n}\n.resumeEditor h2{\n  display: inline-block;\n  border-bottom: 1px solid;\n  margin: 1em 0 .5em;\n}\n.resumeEditor h2 ~ p {\n  margin: 6px 0;\n  font-style: oblique;\n}\n.resumeEditor ul,.resumeEditor ol{\n  list-style: none;\n}\n.resumeEditor ul> li::before{\n  content: '\u2022';\n  margin-right: .5em;\n}\n.resumeEditor ol {\n  counter-reset: section;\n}\n.resumeEditor ol li::before {\n  counter-increment: section;\n  content: counters(section, \".\") \" \";\n  margin-right: .5em;\n}\n.resumeEditor ul> li > pre {\n  margin: 5px 0;\n}\n.resumeEditor a {\n  color: rgb(66, 165, 245);\n}\n.resumeEditor blockquote {\n  margin: 1em;\n  padding: .5em;\n  background: #ddd;\n}\n"],
      currentMarkdown: "",
      fullMarkdown: "\n\u59DA\u4E3E\u751F\n----\n\nPython\u5F00\u53D1\u5DE5\u7A0B\u5E08\uFF0C\u5168\u6808\u5F00\u53D1\uFF0C\u76EE\u524D\u5728\u5357\u4EAC\u5DE5\u4F5C\u3002\n\n\u6280\u80FD\n----\n\n* Python \u5F00\u53D1\n* Ruby \u5F00\u53D1\n* PHP \u5F00\u53D1\n* \u524D\u7AEF\u3001Node.js\n\n\u5DE5\u4F5C\u7ECF\u5386\n----\n\n1. \u67EF\u83B1\u7279\n2. \u8F6F\u901A\u52A8\u529B\n3. \u667A\u6CF0\u6ED5\u8FEA\n4. ...\n\n\u9879\u76EE\u7ECF\u9A8C\n----\n1.\u5B89\u5168\u4EA7\u54C1-\u5723\u6597\u58EB\u5E73\u53F0\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1Apycharm\u3001Linux\u3001Windows\n+ **\u76F8\u5173\u6280\u672F**\uFF1APython\u3001flask\u3001tornado\u3001Mysql\u3001sls\u3001odps\u3001Redis\u3001Docker\u3001nginx\u3001supervisor\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n         \u8FD9\u662F\u4E00\u4E2A\u5B89\u5168\u8BCA\u65AD\u5E73\u53F0\uFF0C\u4E3B\u8981\u505Awaf\u3001\u9AD8\u9632\u7C7B\u4EA7\u54C1\u7684\u4E1A\u52A1\u76D1\u63A7\u548C\u5B89\u5168\u8BCA\u65AD\u4EE5\u53CA\u5DE1\u68C0\u7C7B\u670D\u52A1,\n      \u4E3B\u8981\u5B50\u670D\u52A1\u6709:\u4E1A\u52A1\u8FD0\u8425\u3001\u5168\u94FE\u8DEF\u8BCA\u65AD\u3001\u7F51\u7EDC\u8FD0\u8425\u3001\u670D\u52A1\u914D\u7F6E\u3001\u5BA2\u6237\u670D\u52A1\u7B49\u3002 \n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1A\n  &emsp;  1\uFF09\u8D1F\u8D23\u5723\u6597\u58EB\u5E73\u53F0\u4F01\u4E1A\u7F51\u7EDC\u670D\u52A1\u5F00\u53D1\u76F8\u5173\u5DE5\u4F5C;\n  &emsp;  2\uFF09\u4E3B\u8981\u53C2\u4E0E\u5F00\u53D1\u7684\u5FAE\u670D\u52A1\u6709\uFF1A\u5168\u94FE\u8DEF\u3001\u4E1A\u52A1\u8FD0\u8425\u3001\u670D\u52A1\u914D\u7F6E\u3001\u5BA2\u6237\u670D\u52A1\u7B49\u5723\u6597\u58EB\u540E\u53F0\u670D\u52A1;\n  &emsp;  3\uFF09\u72EC\u7ACB\u5B8C\u6210\u4E86\u5168\u94FE\u8DEF\u548C\u4E1A\u52A1\u8FD0\u8425\u540E\u7AEF\u67B6\u6784\u7684\u91CD\u6784\uFF0C\u5E76\u72EC\u7ACB\u5F00\u53D1\u76F8\u5173\u7684\u51E0\u4E2A\u5B50\u670D\u52A1;\n  &emsp;  4\uFF09rds \u6570\u636E\u5E93\u7684\u4F18\u5316\uFF0C\u7F13\u5B58\u65B9\u6848\u7684\u8BBE\u8BA1\uFF0C\u591A\u4EFB\u52A1\u5904\u7406\u7B49\u7B49\uFF0C\u540C\u65F6\uFF0C\u8D1F\u8D23\u4E1A\u52A1\u76D1\u63A7\u548C\u7F51\u7EDC\u544A\u8B66\u7684\u4F18\u5316\u548C\u670D\u52A1\u6027\u80FD\u63D0\u5347;\n  &emsp;  5\uFF09\u6570\u636E\u5E93\u5B58\u50A8\u8FC7\u7A0B\uFF0C\u5B9A\u65F6\u89E6\u53D1\u5668\uFF0C\u67E5\u8BE2\u4F18\u5316\uFF0C\u6570\u636E\u5E93\u76D1\u63A7;\n  &emsp;  6\uFF09\u4E1A\u52A1\u76D1\u63A7\u548C\u81EA\u5B9A\u4E49\u76D1\u63A7\u7684\u8BBE\u8BA1\u4E0E\u5F00\u53D1;\n  &emsp;  7\uFF09\u5206\u5E03\u5F0F\u548C\u5B9A\u65F6\u6846\u67B6\uFF0C\u5B9A\u65F6\u5E94\u7528\u7684\u5F00\u53D1\uFF1A\n  &emsp;  8\uFF09\u8FD0\u7EF4\u90E8\u7F72\uFF1Adocker\uFF0Cpm2\uFF0Csupervisor\uFF0Cgunicron.\n\n2.Dialog\u65E5\u5FD7\u5206\u6790\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1Apycharm\u3001Windows\n+ **\u76F8\u5173\u6280\u672F**\uFF1APython\u3001MongoDB\u3001XML\u89E3\u6790\uFF08xml.etree.ElementTree\u6A21\u5757+lxml\uFF09\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n          \u901A\u8FC7\u63A5\u6536\u7EC8\u7AEF\u65E5\u5FD7\u6216xml\u6587\u4EF6\uFF08\u6A21\u677F\uFF09\uFF0C\u591A\u7EBF\u7A0B\u4EE3\u7801\u89E3\u6790\u4E0D\u540Cxml\u6A21\u677F\uFF0C\u5B9E\u73B0dom\u6811\u7684\u521B\u5EFA\uFF0C\u89E3\u6790xml\uFF08\u547D\u4EE4\u548C\u56DE\u663E\uFF09\uFF0C\n      \u5212\u5206\u8282\u70B9\u548C\u5C5E\u6027\uFF08\u7C7B\u578B\u5B57\u6BB5+\u503C\uFF09\uFF0C\u6309\u7C7B\u578B\u5B58\u5165\u6570\u636E\u5E93\uFF0C\u5B9A\u5236\u5339\u914D\u89C4\u5219\uFF0C\u89E3\u6790\u65E5\u5FD7\u5185\u5BB9\uFF0C\u5339\u914D\u547D\u4EE4\u53CA\u53C2\u6570\uFF0C\u83B7\u53D6\u56DE\u663E\u4FE1\u606F\uFF0C\n      \u5206\u6790\u7C7B\u578B\u5B57\u6BB5\u7684type\u503C\uFF0C\u5224\u65AD\u5408\u6CD5\u6027\uFF0C\u63D0\u53D6\u9519\u8BEF\u4FE1\u606F\uFF0C\u5411\u4E0A\u5C42\u53CD\u9988\uFF0C\u505A\u5B58\u5165\u6587\u672C\u6216\u6570\u636E\u5E93\u5904\u7406\uFF0C\u5E76\u663E\u793A\uFF0C\u4F9B\u8C03\u7528\u3002\n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1Axml\u89E3\u6790\uFF0CNode\u8282\u70B9\u67E5\u627E\u4E0E\u5339\u914D\uFF1B\u6570\u636E\u5E93\u63A5\u53E3\u7F16\u5199\uFF1B\u65E5\u5FD7\u89E3\u6790\u4E0E\u53CD\u9988\uFF1B\n\n3.\u4EFF\u771FSTA+CMS\u96C6\u4E2D\u63A7\u5236\u7CFB\u7EDF\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1ARubyMine\u3001Windows\n+ **\u76F8\u5173\u6280\u672F**\uFF1Aruby\u3001sqlite\u3001JavaScript\u3001HTML5\u3001CSS\u3001Bootstrap\u3001WLAN\u3001802.11\u534F\u8BAE\u3001802.1x\u8BA4\u8BC1\u534F\u8BAE\u7B49\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n          \u6839\u636E\u771F\u5B9E\u7EC8\u7AEF\u8FDE\u63A5WLAN\u4FE1\u53F7\uFF0C\u6A21\u62DF\u7EC8\u7AEF\u8BBE\u5907\uFF08PC\uFF09\u4E0E\u6A21\u62DFAP\u4EA4\u4E92\u8FC7\u7A0B\u6765\u5B9E\u73B0\u4EFF\u771F\uFF0C\u5173\u8054\u6A21\u62DFAP\uFF0C\n      \u7EC8\u7AEF\u7279\u5F81\u5BFC\u5165open\u3001wap2\u3001dhcp\u3001dot1x\u7B49\u6D41\u7A0B\u771F\u5B9E\u62A5\u6587\uFF0C\u6570\u636E\u5E93\u5B58\u50A8\u76F8\u5E94\u62A5\u6587\u683C\u5F0F\uFF1B\u65B0\u5EFA\u7EC8\u7AEFsta\uFF0C\n      \u9009\u5B9A\u6D41\u7A0B\uFF0C\u6DFB\u52A0\u76F8\u5E94\u62A5\u6587\u683C\u5F0F\uFF0C\u7F16\u8F91\u62A5\u6587\u5185\u5BB9 \uFF0C\u53D1\u9001\u6A21\u62DFAP\uFF0CAP\u4FA7\u5BF9\u62A5\u6587\u5904\u7406\u4E0A\u4F20AC\u63A5\u53D7\u63A7\u5236\uFF0C\u540C\u65F6\u56DE\u5E94sta\uFF0C\u8FDB\u5165\u4E0B\u4E00\u4E2A\u6D41\u7A0B\uFF1B\n      \u7EC8\u7AEF\u591A\u6837\u5316\uFF08\u81EA\u5B9A\u4E49\u7EC8\u7AEF\u3001\u955C\u50CF\u53D1\u5305\u5668\u3001\u56FA\u5B9A\u7EC8\u7AEF\uFF09\uFF0C\u53EF\u6839\u636E\u9700\u8981\u8FDB\u884C\u9009\u578B\uFF0C\u540C\u65F6\u5BF9\u7EC8\u7AEF\u4FE1\u606F\u4EE5\u53CA\u62A5\u6587\u5185\u5BB9\u8FDB\u884C\u7F16\u8F91\u81EA\u5B9A\u4E49\u4FEE\u6539\uFF0C\n      \u5982\u6A21\u62DF\u7EC8\u7AEF\u6570\uFF0Cmac\u6B65\u957F\uFF0C\u662F\u5426\u6301\u7EED\u91CD\u590D\u4E0A\u7EBF\u6D41\u7A0B\uFF0C\u4FE1\u53F7\u8FDE\u63A5\uFF08\u4FE1\u9053\u3001\u5C04\u9891\u3001\u529F\u7387\u3001\u901F\u7387\u3001mac\u7B49\u4FE1\u606F\uFF09\u3001\n      \u62A5\u6587\u7F16\u8F91\u4FEE\u6539\uFF08\u53D1\u9001\u6B21\u6570\u3001\u6D41\u7A0B\u9009\u62E9\uFF0C\u7B49\u5F85\u65F6\u95F4\uFF0C\u8D85\u65F6\u65F6\u95F4\uFF0C\u5E27\u7C7B\u578B\u3001\u6E90/\u76EE\u7684mac\u3001content\uFF0C\u5931\u8D25\u91CD\u4F20\u6B21\u6570\u7B49\uFF09\uFF1B\n      \u5BF9\u4E8E\u5173\u8054\u4FE1\u53F7\u9009\u62E9\uFF0C\u5EFA\u7ACBwebsocket\uFF0C\u81EA\u52A8\u641C\u5BFBWiFi\u4FE1\u53F7\uFF0C\u4EE5\u9875\u9762\u62D6\u62FD\u65B9\u5F0F\u586B\u5165\u7EC8\u7AEF\uFF0C\u6A21\u62DF\u5173\u8054\u9009\u62E9\u8FC7\u7A0B\u3002\n      CMS\u7CFB\u7EDF\u5206\u4E09\u5757\uFF1A\u4EFB\u52A1\u7BA1\u7406\u3001\u7EC8\u7AEF\u7BA1\u7406\u3001\u914D\u7F6E\u7BA1\u7406\uFF0C\u4E09\u4E2A\u6A21\u5757\u534F\u540C\u5DE5\u4F5C\uFF0C\n      \u901A\u8FC7\u4E0B\u53D1\u542B\u6709\u7279\u5B9A\u914D\u7F6E\u7684\u6307\u5B9A\u7EC8\u7AEF\u7684\u5B9A\u65F6\u4EFB\u52A1\uFF0C\u5BF9\u5173\u8054\u7EC8\u7AEF\u8FDB\u884C\u96C6\u4E2D\u63A7\u5236\u3002\n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1A\n  &emsp;  1\uFF09\u89E3\u51B3ssid\u89E3\u7801\u9519\u8BEF\uFF1B\n  &emsp;  2\uFF09dot1x\u8BA4\u8BC1\u6D41\u7A0B\u72B6\u6001\u673A\uFF0C\u6536\u53D1\u62A5\u6587\u673A\u5236\u524D\u540E\u53F0\u5B9E\u73B0\uFF1B\n  &emsp;  3\uFF09\u4F18\u5316wap2\u6D41\u7A0B\u62A5\u6587\u6536\u53D1\u6D41\u7A0B\u4E0E\u56DB\u6B21\u63E1\u624B\uFF1B\n  &emsp;  4\uFF09open\u6D41\u7A0BDHCP\u6536\u53D1\u673A\u5236\u4F18\u5316\uFF0C\u591A\u7EC8\u7AEF\u4E0A\u7EBF\u63D0\u9AD8\u6210\u529F\u7387\uFF0C\u589E\u52A0\u5931\u8D25\u91CD\u4F20\u673A\u5236\uFF1B\n  &emsp;  5\uFF09\u6536\u62A5\u673A\u5236\u4FEE\u6539\uFF0C\u63D0\u9AD8\u6536\u5305\u6210\u529F\u7387\uFF1B\n  &emsp;  6\uFF09\u6DFB\u52A0open\u6253\u6D41\uFF1B\n  &emsp;  7\uFF09\u591A\u4EFB\u52A1\u5206\u6279\u4E0A\u7EBF\u673A\u5236\uFF1B\n  &emsp;  8\uFF09CMS\u96C6\u4E2D\u63A7\u5236\u7CFB\u7EDF\u6574\u6539\u4E0E\u8BBE\u8BA1\uFF1B\n  &emsp;  9\uFF09wpa2\u6DFB\u52A0DHCP\u548C\u6253\u6D41\uFF1B\n  &emsp;  10\uFF09\u6DFB\u52A0\u56DB\u6B21\u63E1\u624B\u540E\u62A5\u6587\u4EA4\u4E92\u4E2D\u5BF9\u6570\u636E\u5E27\u7684\u52A0\u89E3\u5BC6\uFF1B\n\n4.PNF\u6D41\u6C34\u7EBF\u90E8\u7F72\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1Apycharm\u3001Windows\u3001notepad++\n+ **\u76F8\u5173\u6280\u672F**\uFF1Apython\u3001XML\u3001YAML\u3001INI\u7B49\u6587\u4EF6\u89E3\u6790\u3001\u8FDC\u7A0B\u63A7\u5236\u4E0E\u7F51\u7EDC\u8FDE\u63A5\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n          python\u642D\u5EFA\u7684\u4E00\u4E2APNF\u6D41\u6C34\u7EBF\u90E8\u7F72\u5DE5\u5177\uFF0Cdeploy\u5206\u4E3A\u56DB\u4E2A\u90E8\u5206\uFF1A\u7EC4\u4EF6\u3001\u5B50\u7CFB\u7EDF\u76F8\u5173\u3001\u53CD\u5411\u96C6\u6210\u3001\u81EA\u52A8\u751F\u6210\u90E8\u7F72\u73AF\u5883\u7684\u914D\u7F6E\uFF0C\n      \u901A\u8FC7\u5BF9env\u4E2DXML\u548CYAML\u7684\u89E3\u6790\uFF0C\u81EA\u52A8\u751F\u6210config.ini\u914D\u7F6E\u6587\u4EF6\uFF0C\n      \u901A\u8FC7\u89E3\u6790\u914D\u7F6E\u6587\u4EF6\uFF0C\u90E8\u7F72\u76F8\u5E94\u7684\u73AF\u5883\u3002\n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1A\n  &emsp;  1\uFF09\u5BF9\u914D\u7F6E\u751F\u6210\u6A21\u5757\u4E0E\u90E8\u7F72\u6A21\u5757\u8FDB\u884C\u4EE3\u7801\u91CD\u6784\uFF08\u62C6\u5206\u529F\u80FD\uFF0C\u89E3\u8026\uFF0C\u4F18\u5316\uFF0C\u63D0\u9AD8\u4EE3\u7801\u590D\u7528\u7387\u7B49\uFF09\uFF1B\n  &emsp;  2\uFF09\u6DFB\u52A0\u53CD\u5411\u96C6\u6210\u79CD\u7C7B\uFF1B\n  &emsp;  3\uFF09\u4FEE\u6539\u914D\u7F6E\u6A21\u677F\uFF0C\u589E\u52A0\u8FDB\u7A0B\u67E5\u8BE2\uFF0C\u4F18\u5316\u5927\u5305\u68C0\u6D4B\uFF0C\u6DFB\u52A0\u81EA\u52A8\u90E8\u7F72\uFF1B\n  &emsp;  4\uFF09\u5BF9sswm\u5B50\u7CFB\u7EDF\uFF08\u6570\u5B57\u7B7E\u540D+\u975E\u6570\u5B57\u7B7E\u540D\uFF09\u6D41\u7A0B\u9002\u914D\u4FEE\u6539\uFF0C\u6587\u4EF6\u68C0\u6D4B\u3001\u7AEF\u5BF9\u7AEF\u6587\u4EF6\u538B\u7F29\u4E0A\u4F20\u4E0E\u89E3\u6790\u3001\u8FDB\u7A0B\u76D1\u63A7\uFF1B\n  &emsp;  5\uFF09\u7F16\u5199\u8FDC\u7A0Btar\u5305\u66FF\u6362\u5DE5\u5177\uFF08GUI\uFF09;\n  &emsp;  6\uFF09\u7F16\u5199\u9ED1\u767D\u540D\u5355\u53CA\u7279\u6B8A\u7C7B\u578B\u8FC7\u6EE4\u5DE5\u5177;\n  &emsp;  7\uFF09\u7F16\u5199Linux\u547D\u4EE4\u884C\u65E5\u5FD7\u89E3\u6790\uFF0C\u547D\u4EE4\u4E0E\u5404\u7C7B\u53C2\u6570\u56DE\u663E\u68C0\u6D4B\u5206\u6790\u5DE5\u5177\u3002\n\n5.Taidii \u6559\u80B2\u7CFB\u7EDF\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1Apycharm\u3001Linux\n+ **\u76F8\u5173\u6280\u672F**\uFF1APython\u3001Django\u3001Mysql\u3001Redis\u3001JavaScript\u3001Ajax\u3001HTML\u3001JSON\u3001VUE\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n         \u672C\u4EA7\u54C1\u4E3A\u5C11\u513F\u6559\u80B2\u7CFB\u7EDF\uFF0C\u5206web\u7AEF\uFF0CAPP\u7AEF\u7B49\uFF0C\u57FA\u4E8EDjango\uFF08rest-framework\uFF09\u6846\u67B6\uFF0C\u7ED3\u5408MySQL\uFF0CRedis\u6570\u636E\u5E93\uFF0C\n      \u901A\u8FC7HTML+JavaScript+css\u6837\u5F0F\u5411\u7528\u6237\u5C55\u793A\u7684\u5B66\u6821\u4FE1\u606F\uFF0C\u540C\u65F6\u7528\u6237\u53EF\u4EE5\u901A\u8FC7\u4E0D\u540C\u6A21\u5757\u5411\u670D\u52A1\u5668\u53D1\u9001\u76F8\u5E94\u8BF7\u6C42\uFF0C\n      \u670D\u52A1\u5668\u901A\u8FC7Ajax+JSON\u6280\u672F\u548C\u5BA2\u6237\u7AEF\u8FDB\u884C\u4EA4\u4E92\uFF0C\u6536\u96C6\u7528\u6237\u4FE1\u606F\uFF0C\u8FD4\u56DE\u76F8\u5E94\u9875\u9762\u548C\u4FE1\u606F\uFF0C\u4EE5\u4F9B\u7528\u6237\u83B7\u53D6\u548C\u4E0B\u4E00\u6B65\u64CD\u4F5C\u3002 \n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1A\n  &emsp;  1\uFF09\u6210\u957F\u8BB0\u5F55\u518C\u7167\u7247\u663E\u793A\u4F18\u5316\uFF0C\n  &emsp;  2\uFF09\u7269\u8D44\u7BA1\u7406\u6A21\u5757\u91CD\u6784\u4E0E\u6574\u6539\uFF0C\n  &emsp;  3\uFF09\u6821\u56ED\u98CE\u91C7\u6D3B\u52A8\u9875\u5C55\u793A\u3001\u56FE\u7247\u89C6\u9891\u4E0A\u4F20\uFF0C\n  &emsp;  4\uFF09\u8BFE\u7A0B\u8868\u5FEB\u901F\u5F55\u5165\uFF0C\u95EE\u5377\u8C03\u67E5\uFF0C\n  &emsp;  5\uFF09\u4E2D\u82F1\u6587\u7FFB\u8BD1\uFF0C\u6DFB\u52A0\u5E76\u8BBE\u7F6E\u6743\u9650\uFF0C\n  &emsp;  6\uFF09bug\u4FEE\u6539\u7B49\uFF1A\n\n\u5176\u4ED6\n----\n1.**\u722C\u866B**\n\n  - \u7F51\u7EDC\u4FE1\u606F\u91C7\u96C6\n  - \u7B80\u5386\u5206\u6790\u4E0E\u6536\u96C6\n\n2.**\u7F51\u7AD9**\n\n  + \u8D2D\u7269 \uFF08python+web\u524D\u7AEF\uFF09\n  + \u5FAE\u535A\u5BA2\uFF08python + tornado + web\u524D\u7AEF\uFF09\n  + \u4E2A\u4EBA\u535A\u5BA2\uFF08nodejs + \u524D\u7AEF\uFF09\n    &emsp;  1\uFF09[Hexo + yilia](https://github.com/YaoJusheng/hexo-theme-yilia-plus) \u4FEE\u6539\u548C\u5B8C\u5584\n    &emsp;  2\uFF09[Hexo + next](https://github.com/YaoJusheng/hexo-theme-next) \u4FEE\u6539\u548C\u5B8C\u5584\n    &emsp;  3\uFF09[Hexo + diaspora](https://github.com/YaoJusheng/hexo-theme-diaspora) \u4FEE\u6539\u548C\u5B8C\u5584\n    &emsp;  4\uFF09[Hexo + landscape](https://github.com/YaoJusheng/hexo-theme-landscape) \u4FEE\u6539\u548C\u5B8C\u5584\n    &emsp;  5\uFF09[Hexo + icarus](https://github.com/YaoJusheng/hexo-theme-icarus) \u4FEE\u6539\u548C\u5B8C\u5584\n  + \u7B80\u5386\uFF08nodejs + \u524D\u7AEF\uFF09\uFF1A\n    &emsp;  1\uFF09[\u9759\u6001\u7B80\u5386-resume](https://github.com/YaoJusheng/resume)\n    &emsp;  2\uFF09[\u9759\u6001\u7B80\u5386-static-resume](https://github.com/YaoJusheng/static-resume)\n    &emsp;  3\uFF09[\u7B80\u5386\u5236\u4F5C-online-resume](https://github.com/YaoJusheng/online-resume)\n    &emsp;  4\uFF09[\u52A8\u6001\u7B80\u5386-dynamic-resume](https://github.com/YaoJusheng/dynamic-resume)\n\n3.**\u7CFB\u7EDF**\n\n  - CMS\u7CFB\u7EDF\u5F00\u53D1\uFF08PHP + laravel\uFF09\n  - ...\n\n\u94FE\u63A5\n----\n\n* [GitHub](https://github.com/yaojusheng)\n* [CSDN](https://blog.csdn.net/weixin_41599858)\n* [\u6211\u7684\u535A\u5BA21](https://blog.yaogro.cn)\n* [\u6211\u7684\u535A\u5BA22](https://yaojusheng.gitee.io/blog/)\n\n> \u5982\u679C\u4F60\u559C\u6B22\u8FD9\u4E2A\u6548\u679C\uFF0CFork [\u6211\u7684\u9879\u76EE](https://github.com/yaojusheng/dynamic-resume)\uFF0C\u6253\u9020\u4F60\u81EA\u5DF1\u7684\u7B80\u5386\uFF01\n\n"
    };
  },
  created: function created() {
    this.makeResume();
  },


  methods: {
    makeResume: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.progressivelyShowStyle(0);

              case 2:
                _context.next = 4;
                return this.progressivelyShowResume();

              case 4:
                _context.next = 6;
                return this.progressivelyShowStyle(1);

              case 6:
                _context.next = 8;
                return this.showHtml();

              case 8:
                _context.next = 10;
                return this.progressivelyShowStyle(2);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function makeResume() {
        return _ref.apply(this, arguments);
      }

      return makeResume;
    }(),
    showHtml: function showHtml() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.enableHtml = true;
        resolve();
      });
    },
    progressivelyShowStyle: function progressivelyShowStyle(n) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var interval = _this2.interval;
        var showStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var _this3 = this;

          var style, length, prefixLength, l, char;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  style = this.fullStyle[n];

                  if (style) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt("return");

                case 3:
                  length = this.fullStyle.filter(function (_, index) {
                    return index <= n;
                  }).map(function (item) {
                    return item.length;
                  }).reduce(function (p, c) {
                    return p + c;
                  }, 0);
                  prefixLength = length - style.length;

                  if (this.currentStyle.length < length) {
                    l = this.currentStyle.length - prefixLength;
                    char = style.substring(l, l + 1) || " ";

                    this.currentStyle += char;
                    if (style.substring(l - 1, l) === "\n" && this.$refs.styleEditor) {
                      this.$nextTick(function () {
                        _this3.$refs.styleEditor.goBottom();
                      });
                    }
                    setTimeout(showStyle, interval);
                  } else {
                    resolve();
                  }

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        })).bind(_this2);
        showStyle();
      });
    },
    progressivelyShowResume: function progressivelyShowResume() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var length = _this4.fullMarkdown.length;
        var interval = _this4.interval;
        var showResume = function showResume() {
          if (_this4.currentMarkdown.length < length) {
            _this4.currentMarkdown = _this4.fullMarkdown.substring(0, _this4.currentMarkdown.length + 1);
            var lastChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 1];
            var prevChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 2];
            if (prevChar === "\n" && _this4.$refs.resumeEditor) {
              _this4.$nextTick(function () {
                return _this4.$refs.resumeEditor.goBottom();
              });
            }
            setTimeout(showResume, interval);
          } else {
            resolve();
          }
        };
        showResume();
      });
    }
  }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StyleEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_reset_css__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    StyleEditor: __WEBPACK_IMPORTED_MODULE_3__components_StyleEditor___default.a,
    ResumeEditor: __WEBPACK_IMPORTED_MODULE_4__components_ResumeEditor___default.a
  },
  data: function data() {
    return {
      interval: 3,
      currentStyle: "",
      enableHtml: false,
      fullStyle: ["/*\n* Inspired by http://strml.net/\n* \u5927\u5BB6\u597D\uFF0C\u6211\u662F\u8001\u59DA\n* \u6BCF\u5929\u90FD\u6709\u5F88\u591A\u4EBA\u5728\u6C42\u804C\u7684\u8DEF\u4E0A\uFF0C\u5728\u7EBF\u7B80\u5386\u5FC5\u4E0D\u53EF\u5C11\u3002\n* \u8FD9\u91CC\u8DDF\u4E2A\u98CE\uFF0C\u6211\u4E5F\u6765\u5199\u4E00\u4EFD\u7B80\u5386\uFF01\n*/\n\n/* \u9996\u5148\u7ED9\u6240\u6709\u5143\u7D20\u52A0\u4E0A\u8FC7\u6E21\u6548\u679C */\n* {\n  transition: all .1s;\n}\n\n/* \u8BBE\u7F6E\u80CC\u666F\u989C\u8272 */\nhtml {\n  color: rgb(222,222,222);\n  background: rgb(0,43,54);\n}\n\n/* \u8BBE\u7F6E\u8FB9\u6846 */\n.styleEditor {\n  padding: .5em;\n  border: 1px solid;\n  overflow: auto;\n  width: 90vw;\n  margin: 2.5vh 5vw;\n  height: 90vh;\n}\n\n/* \u8BBE\u7F6E\u9AD8\u5EA6 */\n.styleEditor {\n  height: 45vh;\n}\n\n/* \u4EE3\u7801\u9AD8\u4EAE */\n.token.selector{\n  color: rgb(133,153,0);\n}\n.token.property{\n  color: rgb(187,137,0);\n}\n.token.punctuation{\n  color: yellow;\n}\n.token.function{\n  color: rgb(42,161,152);\n}\n\n/* \u52A03D\u6548\u679C */\nhtml{\n  perspective: 1000px;\n}\n.styleEditor {\n  position: fixed; left: 0; top: 0;\n  transform: rotateX(-10deg) translateZ(-50px) ;\n}\n\n/* \u51C6\u5907\u4E00\u4E2A\u7F16\u8F91\u5668 */\n.resumeEditor{\n  position: fixed;\n  top: 50%; left: 0;\n  padding: .5em;  margin: 2.5vh;\n  width: 95vw; height: 45vh;\n  border: 1px solid;\n  background: white; color: #222;\n  overflow: auto;\n}\n\n/* \u73B0\u5728\uFF0C\u5F00\u59CB\u5199\u7B80\u5386 */\n", "\n/*\u5C06Markdown\u683C\u5F0F\u7FFB\u8BD1\u6210HTML\n *\u518D\u5BF9HTML\u52A0\u70B9\u6837\u5F0F\n*/\n.resumeEditor{\n  padding: 2em;\n}\n.resumeEditor h2{\n  display: inline-block;\n  border-bottom: 1px solid;\n  margin: 1em 0 .5em;\n}\n.resumeEditor h2 ~ p {\n  margin: 6px 0;\n  font-style: oblique;\n}\n.resumeEditor ul,.resumeEditor ol{\n  list-style: none;\n}\n.resumeEditor ul> li::before{\n  content: '\u2022';\n  margin-right: .5em;\n}\n.resumeEditor ul> li > pre {\n  margin: 5px 0;\n}\n.resumeEditor ol {\n  counter-reset: section;\n}\n.resumeEditor ol li::before {\n  counter-increment: section;\n  content: counters(section, \".\") \" \";\n  margin-right: .5em;\n}\n.resumeEditor a {\n  color: rgb(66, 165, 245);\n}\n.resumeEditor blockquote {\n  margin: 1em;\n  padding: .5em;\n  background: #ddd;\n}\n"],
      currentMarkdown: "",
      fullMarkdown: "\n\u59DA\u4E3E\u751F\n----\n\nPython\u5F00\u53D1\u5DE5\u7A0B\u5E08\uFF0C\u5168\u6808\u5F00\u53D1\uFF0C\u76EE\u524D\u5728\u5357\u4EAC\u5DE5\u4F5C\u3002\n\n\u6280\u80FD\n----\n\n* Python \u5F00\u53D1\n* Ruby \u5F00\u53D1\n* PHP \u5F00\u53D1\n* \u524D\u7AEF\u3001Node.js\n\n\u5DE5\u4F5C\u7ECF\u5386\n----\n\n1. \u67EF\u83B1\u7279\n2. \u8F6F\u901A\u52A8\u529B\n3. \u667A\u6CF0\u6ED5\u8FEA\n4. ...\n\n\u9879\u76EE\u7ECF\u9A8C\n----\n1.\u5B89\u5168\u4EA7\u54C1-\u5723\u6597\u58EB\u5E73\u53F0\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1Apycharm\u3001Linux\u3001Windows\n+ **\u76F8\u5173\u6280\u672F**\uFF1APython\u3001flask\u3001tornado\u3001Mysql\u3001sls\u3001odps\u3001Redis\u3001Docker\u3001nginx\u3001supervisor\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n         \u8FD9\u662F\u4E00\u4E2A\u5B89\u5168\u8BCA\u65AD\u5E73\u53F0\uFF0C\u4E3B\u8981\u505Awaf\u3001\u9AD8\u9632\u7C7B\u4EA7\u54C1\u7684\u4E1A\u52A1\u76D1\u63A7\u548C\u5B89\u5168\u8BCA\u65AD\u4EE5\u53CA\u5DE1\u68C0\u7C7B\u670D\u52A1,\n      \u4E3B\u8981\u5B50\u670D\u52A1\u6709:\u4E1A\u52A1\u8FD0\u8425\u3001\u5168\u94FE\u8DEF\u8BCA\u65AD\u3001\u7F51\u7EDC\u8FD0\u8425\u3001\u670D\u52A1\u914D\u7F6E\u3001\u5BA2\u6237\u670D\u52A1\u7B49\u3002 \n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1A\n  &emsp;  1\uFF09\u8D1F\u8D23\u5723\u6597\u58EB\u5E73\u53F0\u4F01\u4E1A\u7F51\u7EDC\u670D\u52A1\u5F00\u53D1\u76F8\u5173\u5DE5\u4F5C;\n  &emsp;  2\uFF09\u4E3B\u8981\u53C2\u4E0E\u5F00\u53D1\u7684\u5FAE\u670D\u52A1\u6709\uFF1A\u5168\u94FE\u8DEF\u3001\u4E1A\u52A1\u8FD0\u8425\u3001\u670D\u52A1\u914D\u7F6E\u3001\u5BA2\u6237\u670D\u52A1\u7B49\u5723\u6597\u58EB\u540E\u53F0\u670D\u52A1;\n  &emsp;  3\uFF09\u72EC\u7ACB\u5B8C\u6210\u4E86\u5168\u94FE\u8DEF\u548C\u4E1A\u52A1\u8FD0\u8425\u540E\u7AEF\u67B6\u6784\u7684\u91CD\u6784\uFF0C\u5E76\u72EC\u7ACB\u5F00\u53D1\u76F8\u5173\u7684\u51E0\u4E2A\u5B50\u670D\u52A1;\n  &emsp;  4\uFF09rds \u6570\u636E\u5E93\u7684\u4F18\u5316\uFF0C\u7F13\u5B58\u65B9\u6848\u7684\u8BBE\u8BA1\uFF0C\u591A\u4EFB\u52A1\u5904\u7406\u7B49\u7B49\uFF0C\u540C\u65F6\uFF0C\u8D1F\u8D23\u4E1A\u52A1\u76D1\u63A7\u548C\u7F51\u7EDC\u544A\u8B66\u7684\u4F18\u5316\u548C\u670D\u52A1\u6027\u80FD\u63D0\u5347;\n  &emsp;  5\uFF09\u6570\u636E\u5E93\u5B58\u50A8\u8FC7\u7A0B\uFF0C\u5B9A\u65F6\u89E6\u53D1\u5668\uFF0C\u67E5\u8BE2\u4F18\u5316\uFF0C\u6570\u636E\u5E93\u76D1\u63A7;\n  &emsp;  6\uFF09\u4E1A\u52A1\u76D1\u63A7\u548C\u81EA\u5B9A\u4E49\u76D1\u63A7\u7684\u8BBE\u8BA1\u4E0E\u5F00\u53D1;\n  &emsp;  7\uFF09\u5206\u5E03\u5F0F\u548C\u5B9A\u65F6\u6846\u67B6\uFF0C\u5B9A\u65F6\u5E94\u7528\u7684\u5F00\u53D1\uFF1A\n  &emsp;  8\uFF09\u8FD0\u7EF4\u90E8\u7F72\uFF1Adocker\uFF0Cpm2\uFF0Csupervisor\uFF0Cgunicron.\n\n2.Dialog\u65E5\u5FD7\u5206\u6790\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1Apycharm\u3001Windows\n+ **\u76F8\u5173\u6280\u672F**\uFF1APython\u3001MongoDB\u3001XML\u89E3\u6790\uFF08xml.etree.ElementTree\u6A21\u5757+lxml\uFF09\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n          \u901A\u8FC7\u63A5\u6536\u7EC8\u7AEF\u65E5\u5FD7\u6216xml\u6587\u4EF6\uFF08\u6A21\u677F\uFF09\uFF0C\u591A\u7EBF\u7A0B\u4EE3\u7801\u89E3\u6790\u4E0D\u540Cxml\u6A21\u677F\uFF0C\u5B9E\u73B0dom\u6811\u7684\u521B\u5EFA\uFF0C\u89E3\u6790xml\uFF08\u547D\u4EE4\u548C\u56DE\u663E\uFF09\uFF0C\n      \u5212\u5206\u8282\u70B9\u548C\u5C5E\u6027\uFF08\u7C7B\u578B\u5B57\u6BB5+\u503C\uFF09\uFF0C\u6309\u7C7B\u578B\u5B58\u5165\u6570\u636E\u5E93\uFF0C\u5B9A\u5236\u5339\u914D\u89C4\u5219\uFF0C\u89E3\u6790\u65E5\u5FD7\u5185\u5BB9\uFF0C\u5339\u914D\u547D\u4EE4\u53CA\u53C2\u6570\uFF0C\u83B7\u53D6\u56DE\u663E\u4FE1\u606F\uFF0C\n      \u5206\u6790\u7C7B\u578B\u5B57\u6BB5\u7684type\u503C\uFF0C\u5224\u65AD\u5408\u6CD5\u6027\uFF0C\u63D0\u53D6\u9519\u8BEF\u4FE1\u606F\uFF0C\u5411\u4E0A\u5C42\u53CD\u9988\uFF0C\u505A\u5B58\u5165\u6587\u672C\u6216\u6570\u636E\u5E93\u5904\u7406\uFF0C\u5E76\u663E\u793A\uFF0C\u4F9B\u8C03\u7528\u3002\n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1Axml\u89E3\u6790\uFF0CNode\u8282\u70B9\u67E5\u627E\u4E0E\u5339\u914D\uFF1B\u6570\u636E\u5E93\u63A5\u53E3\u7F16\u5199\uFF1B\u65E5\u5FD7\u89E3\u6790\u4E0E\u53CD\u9988\uFF1B\n\n3.\u4EFF\u771FSTA+CMS\u96C6\u4E2D\u63A7\u5236\u7CFB\u7EDF\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1ARubyMine\u3001Windows\n+ **\u76F8\u5173\u6280\u672F**\uFF1Aruby\u3001sqlite\u3001JavaScript\u3001HTML5\u3001CSS\u3001Bootstrap\u3001WLAN\u3001802.11\u534F\u8BAE\u3001802.1x\u8BA4\u8BC1\u534F\u8BAE\u7B49\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n          \u6839\u636E\u771F\u5B9E\u7EC8\u7AEF\u8FDE\u63A5WLAN\u4FE1\u53F7\uFF0C\u6A21\u62DF\u7EC8\u7AEF\u8BBE\u5907\uFF08PC\uFF09\u4E0E\u6A21\u62DFAP\u4EA4\u4E92\u8FC7\u7A0B\u6765\u5B9E\u73B0\u4EFF\u771F\uFF0C\u5173\u8054\u6A21\u62DFAP\uFF0C\n      \u7EC8\u7AEF\u7279\u5F81\u5BFC\u5165open\u3001wap2\u3001dhcp\u3001dot1x\u7B49\u6D41\u7A0B\u771F\u5B9E\u62A5\u6587\uFF0C\u6570\u636E\u5E93\u5B58\u50A8\u76F8\u5E94\u62A5\u6587\u683C\u5F0F\uFF1B\u65B0\u5EFA\u7EC8\u7AEFsta\uFF0C\n      \u9009\u5B9A\u6D41\u7A0B\uFF0C\u6DFB\u52A0\u76F8\u5E94\u62A5\u6587\u683C\u5F0F\uFF0C\u7F16\u8F91\u62A5\u6587\u5185\u5BB9 \uFF0C\u53D1\u9001\u6A21\u62DFAP\uFF0CAP\u4FA7\u5BF9\u62A5\u6587\u5904\u7406\u4E0A\u4F20AC\u63A5\u53D7\u63A7\u5236\uFF0C\u540C\u65F6\u56DE\u5E94sta\uFF0C\u8FDB\u5165\u4E0B\u4E00\u4E2A\u6D41\u7A0B\uFF1B\n      \u7EC8\u7AEF\u591A\u6837\u5316\uFF08\u81EA\u5B9A\u4E49\u7EC8\u7AEF\u3001\u955C\u50CF\u53D1\u5305\u5668\u3001\u56FA\u5B9A\u7EC8\u7AEF\uFF09\uFF0C\u53EF\u6839\u636E\u9700\u8981\u8FDB\u884C\u9009\u578B\uFF0C\u540C\u65F6\u5BF9\u7EC8\u7AEF\u4FE1\u606F\u4EE5\u53CA\u62A5\u6587\u5185\u5BB9\u8FDB\u884C\u7F16\u8F91\u81EA\u5B9A\u4E49\u4FEE\u6539\uFF0C\n      \u5982\u6A21\u62DF\u7EC8\u7AEF\u6570\uFF0Cmac\u6B65\u957F\uFF0C\u662F\u5426\u6301\u7EED\u91CD\u590D\u4E0A\u7EBF\u6D41\u7A0B\uFF0C\u4FE1\u53F7\u8FDE\u63A5\uFF08\u4FE1\u9053\u3001\u5C04\u9891\u3001\u529F\u7387\u3001\u901F\u7387\u3001mac\u7B49\u4FE1\u606F\uFF09\u3001\n      \u62A5\u6587\u7F16\u8F91\u4FEE\u6539\uFF08\u53D1\u9001\u6B21\u6570\u3001\u6D41\u7A0B\u9009\u62E9\uFF0C\u7B49\u5F85\u65F6\u95F4\uFF0C\u8D85\u65F6\u65F6\u95F4\uFF0C\u5E27\u7C7B\u578B\u3001\u6E90/\u76EE\u7684mac\u3001content\uFF0C\u5931\u8D25\u91CD\u4F20\u6B21\u6570\u7B49\uFF09\uFF1B\n      \u5BF9\u4E8E\u5173\u8054\u4FE1\u53F7\u9009\u62E9\uFF0C\u5EFA\u7ACBwebsocket\uFF0C\u81EA\u52A8\u641C\u5BFBWiFi\u4FE1\u53F7\uFF0C\u4EE5\u9875\u9762\u62D6\u62FD\u65B9\u5F0F\u586B\u5165\u7EC8\u7AEF\uFF0C\u6A21\u62DF\u5173\u8054\u9009\u62E9\u8FC7\u7A0B\u3002\n      CMS\u7CFB\u7EDF\u5206\u4E09\u5757\uFF1A\u4EFB\u52A1\u7BA1\u7406\u3001\u7EC8\u7AEF\u7BA1\u7406\u3001\u914D\u7F6E\u7BA1\u7406\uFF0C\u4E09\u4E2A\u6A21\u5757\u534F\u540C\u5DE5\u4F5C\uFF0C\n      \u901A\u8FC7\u4E0B\u53D1\u542B\u6709\u7279\u5B9A\u914D\u7F6E\u7684\u6307\u5B9A\u7EC8\u7AEF\u7684\u5B9A\u65F6\u4EFB\u52A1\uFF0C\u5BF9\u5173\u8054\u7EC8\u7AEF\u8FDB\u884C\u96C6\u4E2D\u63A7\u5236\u3002\n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1A\n  &emsp;  1\uFF09\u89E3\u51B3ssid\u89E3\u7801\u9519\u8BEF\uFF1B\n  &emsp;  2\uFF09dot1x\u8BA4\u8BC1\u6D41\u7A0B\u72B6\u6001\u673A\uFF0C\u6536\u53D1\u62A5\u6587\u673A\u5236\u524D\u540E\u53F0\u5B9E\u73B0\uFF1B\n  &emsp;  3\uFF09\u4F18\u5316wap2\u6D41\u7A0B\u62A5\u6587\u6536\u53D1\u6D41\u7A0B\u4E0E\u56DB\u6B21\u63E1\u624B\uFF1B\n  &emsp;  4\uFF09open\u6D41\u7A0BDHCP\u6536\u53D1\u673A\u5236\u4F18\u5316\uFF0C\u591A\u7EC8\u7AEF\u4E0A\u7EBF\u63D0\u9AD8\u6210\u529F\u7387\uFF0C\u589E\u52A0\u5931\u8D25\u91CD\u4F20\u673A\u5236\uFF1B\n  &emsp;  5\uFF09\u6536\u62A5\u673A\u5236\u4FEE\u6539\uFF0C\u63D0\u9AD8\u6536\u5305\u6210\u529F\u7387\uFF1B\n  &emsp;  6\uFF09\u6DFB\u52A0open\u6253\u6D41\uFF1B\n  &emsp;  7\uFF09\u591A\u4EFB\u52A1\u5206\u6279\u4E0A\u7EBF\u673A\u5236\uFF1B\n  &emsp;  8\uFF09CMS\u96C6\u4E2D\u63A7\u5236\u7CFB\u7EDF\u6574\u6539\u4E0E\u8BBE\u8BA1\uFF1B\n  &emsp;  9\uFF09wpa2\u6DFB\u52A0DHCP\u548C\u6253\u6D41\uFF1B\n  &emsp;  10\uFF09\u6DFB\u52A0\u56DB\u6B21\u63E1\u624B\u540E\u62A5\u6587\u4EA4\u4E92\u4E2D\u5BF9\u6570\u636E\u5E27\u7684\u52A0\u89E3\u5BC6\uFF1B\n\n4.PNF\u6D41\u6C34\u7EBF\u90E8\u7F72\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1Apycharm\u3001Windows\u3001notepad++\n+ **\u76F8\u5173\u6280\u672F**\uFF1Apython\u3001XML\u3001YAML\u3001INI\u7B49\u6587\u4EF6\u89E3\u6790\u3001\u8FDC\u7A0B\u63A7\u5236\u4E0E\u7F51\u7EDC\u8FDE\u63A5\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n          python\u642D\u5EFA\u7684\u4E00\u4E2APNF\u6D41\u6C34\u7EBF\u90E8\u7F72\u5DE5\u5177\uFF0Cdeploy\u5206\u4E3A\u56DB\u4E2A\u90E8\u5206\uFF1A\u7EC4\u4EF6\u3001\u5B50\u7CFB\u7EDF\u76F8\u5173\u3001\u53CD\u5411\u96C6\u6210\u3001\u81EA\u52A8\u751F\u6210\u90E8\u7F72\u73AF\u5883\u7684\u914D\u7F6E\uFF0C\n      \u901A\u8FC7\u5BF9env\u4E2DXML\u548CYAML\u7684\u89E3\u6790\uFF0C\u81EA\u52A8\u751F\u6210config.ini\u914D\u7F6E\u6587\u4EF6\uFF0C\n      \u901A\u8FC7\u89E3\u6790\u914D\u7F6E\u6587\u4EF6\uFF0C\u90E8\u7F72\u76F8\u5E94\u7684\u73AF\u5883\u3002\n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1A\n  &emsp;  1\uFF09\u5BF9\u914D\u7F6E\u751F\u6210\u6A21\u5757\u4E0E\u90E8\u7F72\u6A21\u5757\u8FDB\u884C\u4EE3\u7801\u91CD\u6784\uFF08\u62C6\u5206\u529F\u80FD\uFF0C\u89E3\u8026\uFF0C\u4F18\u5316\uFF0C\u63D0\u9AD8\u4EE3\u7801\u590D\u7528\u7387\u7B49\uFF09\uFF1B\n  &emsp;  2\uFF09\u6DFB\u52A0\u53CD\u5411\u96C6\u6210\u79CD\u7C7B\uFF1B\n  &emsp;  3\uFF09\u4FEE\u6539\u914D\u7F6E\u6A21\u677F\uFF0C\u589E\u52A0\u8FDB\u7A0B\u67E5\u8BE2\uFF0C\u4F18\u5316\u5927\u5305\u68C0\u6D4B\uFF0C\u6DFB\u52A0\u81EA\u52A8\u90E8\u7F72\uFF1B\n  &emsp;  4\uFF09\u5BF9sswm\u5B50\u7CFB\u7EDF\uFF08\u6570\u5B57\u7B7E\u540D+\u975E\u6570\u5B57\u7B7E\u540D\uFF09\u6D41\u7A0B\u9002\u914D\u4FEE\u6539\uFF0C\u6587\u4EF6\u68C0\u6D4B\u3001\u7AEF\u5BF9\u7AEF\u6587\u4EF6\u538B\u7F29\u4E0A\u4F20\u4E0E\u89E3\u6790\u3001\u8FDB\u7A0B\u76D1\u63A7\uFF1B\n  &emsp;  5\uFF09\u7F16\u5199\u8FDC\u7A0Btar\u5305\u66FF\u6362\u5DE5\u5177\uFF08GUI\uFF09;\n  &emsp;  6\uFF09\u7F16\u5199\u9ED1\u767D\u540D\u5355\u53CA\u7279\u6B8A\u7C7B\u578B\u8FC7\u6EE4\u5DE5\u5177;\n  &emsp;  7\uFF09\u7F16\u5199Linux\u547D\u4EE4\u884C\u65E5\u5FD7\u89E3\u6790\uFF0C\u547D\u4EE4\u4E0E\u5404\u7C7B\u53C2\u6570\u56DE\u663E\u68C0\u6D4B\u5206\u6790\u5DE5\u5177\u3002\n\n5.Taidii \u6559\u80B2\u7CFB\u7EDF\n\n+ **\u5DE5\u5177\u73AF\u5883**\uFF1Apycharm\u3001Linux\n+ **\u76F8\u5173\u6280\u672F**\uFF1APython\u3001Django\u3001Mysql\u3001Redis\u3001JavaScript\u3001Ajax\u3001HTML\u3001JSON\u3001VUE\n+ **\u9879\u76EE\u63CF\u8FF0**\uFF1A\n         \u672C\u4EA7\u54C1\u4E3A\u5C11\u513F\u6559\u80B2\u7CFB\u7EDF\uFF0C\u5206web\u7AEF\uFF0CAPP\u7AEF\u7B49\uFF0C\u57FA\u4E8EDjango\uFF08rest-framework\uFF09\u6846\u67B6\uFF0C\u7ED3\u5408MySQL\uFF0CRedis\u6570\u636E\u5E93\uFF0C\n      \u901A\u8FC7HTML+JavaScript+css\u6837\u5F0F\u5411\u7528\u6237\u5C55\u793A\u7684\u5B66\u6821\u4FE1\u606F\uFF0C\u540C\u65F6\u7528\u6237\u53EF\u4EE5\u901A\u8FC7\u4E0D\u540C\u6A21\u5757\u5411\u670D\u52A1\u5668\u53D1\u9001\u76F8\u5E94\u8BF7\u6C42\uFF0C\n      \u670D\u52A1\u5668\u901A\u8FC7Ajax+JSON\u6280\u672F\u548C\u5BA2\u6237\u7AEF\u8FDB\u884C\u4EA4\u4E92\uFF0C\u6536\u96C6\u7528\u6237\u4FE1\u606F\uFF0C\u8FD4\u56DE\u76F8\u5E94\u9875\u9762\u548C\u4FE1\u606F\uFF0C\u4EE5\u4F9B\u7528\u6237\u83B7\u53D6\u548C\u4E0B\u4E00\u6B65\u64CD\u4F5C\u3002 \n+ **\u8D23\u4EFB\u63CF\u8FF0**\uFF1A\n  &emsp;  1\uFF09\u6210\u957F\u8BB0\u5F55\u518C\u7167\u7247\u663E\u793A\u4F18\u5316\uFF0C\n  &emsp;  2\uFF09\u7269\u8D44\u7BA1\u7406\u6A21\u5757\u91CD\u6784\u4E0E\u6574\u6539\uFF0C\n  &emsp;  3\uFF09\u6821\u56ED\u98CE\u91C7\u6D3B\u52A8\u9875\u5C55\u793A\u3001\u56FE\u7247\u89C6\u9891\u4E0A\u4F20\uFF0C\n  &emsp;  4\uFF09\u8BFE\u7A0B\u8868\u5FEB\u901F\u5F55\u5165\uFF0C\u95EE\u5377\u8C03\u67E5\uFF0C\n  &emsp;  5\uFF09\u4E2D\u82F1\u6587\u7FFB\u8BD1\uFF0C\u6DFB\u52A0\u5E76\u8BBE\u7F6E\u6743\u9650\uFF0C\n  &emsp;  6\uFF09bug\u4FEE\u6539\u7B49\uFF1A\n\n\u5176\u4ED6\n----\n1.**\u722C\u866B**\n\n  - \u7F51\u7EDC\u4FE1\u606F\u91C7\u96C6\n  - \u7B80\u5386\u5206\u6790\u4E0E\u6536\u96C6\n\n2.**\u7F51\u7AD9**\n\n  + \u8D2D\u7269 \uFF08python+web\u524D\u7AEF\uFF09\n  + \u5FAE\u535A\u5BA2\uFF08python + tornado + web\u524D\u7AEF\uFF09\n  + \u4E2A\u4EBA\u535A\u5BA2\uFF08nodejs + \u524D\u7AEF\uFF09\n    &emsp;  1\uFF09[Hexo + yilia](https://github.com/YaoJusheng/hexo-theme-yilia-plus) \u4FEE\u6539\u548C\u5B8C\u5584\n    &emsp;  2\uFF09[Hexo + next](https://github.com/YaoJusheng/hexo-theme-next) \u4FEE\u6539\u548C\u5B8C\u5584\n    &emsp;  3\uFF09[Hexo + diaspora](https://github.com/YaoJusheng/hexo-theme-diaspora) \u4FEE\u6539\u548C\u5B8C\u5584\n    &emsp;  4\uFF09[Hexo + landscape](https://github.com/YaoJusheng/hexo-theme-landscape) \u4FEE\u6539\u548C\u5B8C\u5584\n    &emsp;  5\uFF09[Hexo + icarus](https://github.com/YaoJusheng/hexo-theme-icarus) \u4FEE\u6539\u548C\u5B8C\u5584\n  + \u7B80\u5386\uFF08nodejs + \u524D\u7AEF\uFF09\uFF1A\n    &emsp;  1\uFF09[\u9759\u6001\u7B80\u5386-resume](https://github.com/YaoJusheng/resume)\n    &emsp;  2\uFF09[\u9759\u6001\u7B80\u5386-static-resume](https://github.com/YaoJusheng/static-resume)\n    &emsp;  3\uFF09[\u7B80\u5386\u5236\u4F5C-online-resume](https://github.com/YaoJusheng/online-resume)\n    &emsp;  4\uFF09[\u52A8\u6001\u7B80\u5386-dynamic-resume](https://github.com/YaoJusheng/dynamic-resume)\n\n3.**\u7CFB\u7EDF**\n\n  - CMS\u7CFB\u7EDF\u5F00\u53D1\uFF08PHP + laravel\uFF09\n  - ...\n\n\u94FE\u63A5\n----\n\n* [GitHub](https://github.com/yaojusheng)\n* [CSDN](https://blog.csdn.net/weixin_41599858)\n* [\u6211\u7684\u535A\u5BA21](https://blog.yaogro.cn)\n* [\u6211\u7684\u535A\u5BA22](https://yaojusheng.gitee.io/blog/)\n\n> \u5982\u679C\u4F60\u559C\u6B22\u8FD9\u4E2A\u6548\u679C\uFF0CFork [\u6211\u7684\u9879\u76EE](https://github.com/yaojusheng/dynamic-resume)\uFF0C\u6253\u9020\u4F60\u81EA\u5DF1\u7684\u7B80\u5386\uFF01\n\n"
    };
  },
  created: function created() {
    this.makeResume();
  },

  methods: {
    makeResume: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.progressivelyShowStyle(0);

              case 2:
                _context.next = 4;
                return this.progressivelyShowResume();

              case 4:
                _context.next = 6;
                return this.progressivelyShowStyle(1);

              case 6:
                _context.next = 8;
                return this.showHtml();

              case 8:
                _context.next = 10;
                return this.progressivelyShowStyle(2);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function makeResume() {
        return _ref.apply(this, arguments);
      }

      return makeResume;
    }(),
    showHtml: function showHtml() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.enableHtml = true;
        _this.$nextTick(function () {
          _this.$refs.resumeEditor.goTop();
        });
        resolve();
      });
    },
    progressivelyShowStyle: function progressivelyShowStyle(n) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var interval = _this2.interval;
        var showStyle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var _this3 = this;

          var style, length, prefixLength, l, char;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  style = this.fullStyle[n];

                  if (style) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt("return");

                case 3:
                  length = this.fullStyle.filter(function (_, index) {
                    return index <= n;
                  }).map(function (item) {
                    return item.length;
                  }).reduce(function (p, c) {
                    return p + c;
                  }, 0);
                  prefixLength = length - style.length;

                  if (this.currentStyle.length < length) {
                    l = this.currentStyle.length - prefixLength;
                    char = style.substring(l, l + 1) || " ";

                    this.currentStyle += char;
                    if (style.substring(l - 1, l) === "\n" && this.$refs.styleEditor) {
                      this.$nextTick(function () {
                        _this3.$refs.styleEditor.goBottom();
                      });
                    }
                    setTimeout(showStyle, interval);
                  } else {
                    resolve();
                  }

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        })).bind(_this2);
        showStyle();
      });
    },
    progressivelyShowResume: function progressivelyShowResume() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var length = _this4.fullMarkdown.length;
        var interval = _this4.interval;
        var showResume = function showResume() {
          if (_this4.currentMarkdown.length < length) {
            _this4.currentMarkdown = _this4.fullMarkdown.substring(0, _this4.currentMarkdown.length + 1);
            var lastChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 1];
            var prevChar = _this4.currentMarkdown[_this4.currentMarkdown.length - 2];
            if (prevChar === "\n" && _this4.$refs.resumeEditor) {
              _this4.$nextTick(function () {
                return _this4.$refs.resumeEditor.goBottom();
              });
            }
            setTimeout(showResume, interval);
          } else {
            resolve();
          }
        };
        showResume();
      });
    }
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["markdown", "enableHtml"],
  name: "ResumeEditor",
  computed: {
    result: function result() {
      var renderer = new __WEBPACK_IMPORTED_MODULE_0_marked___default.a.Renderer();

      __WEBPACK_IMPORTED_MODULE_0_marked___default.a.setOptions({
        renderer: renderer,
        gfm: true,
        tables: true,
        breaks: true,
        pedantic: false,
        sanitize: false,
        smartLists: true,
        smartypants: false });

      var linkRenderer = renderer.link;
      renderer.link = function (href, title, text) {
        var html = linkRenderer.call(renderer, href, title, text);
        return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
      };

      return this.enableHtml ? __WEBPACK_IMPORTED_MODULE_0_marked___default()(this.markdown, { renderer: renderer }) : this.markdown;
    }
  },
  methods: {
    goBottom: function goBottom() {
      this.$refs.container.scrollTop = 100000;
    },
    goTop: function goTop() {
      this.$refs.container.scrollTop = 0;
    }
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Editor",
  props: ["code"],
  computed: {
    highlightedCode: function highlightedCode() {
      return __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.highlight(this.code, __WEBPACK_IMPORTED_MODULE_0_prismjs___default.a.languages.css);
    },
    codeInStyleTag: function codeInStyleTag() {
      return "<style>" + this.code + "</style>";
    }
  },
  methods: {
    goBottom: function goBottom() {
      this.$refs.container.scrollTop = 100000;
    }
  }
});

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mobile__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Mobile__);




var width = document.documentElement.clientWidth;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(width > 500 ? __WEBPACK_IMPORTED_MODULE_1__App___default.a : __WEBPACK_IMPORTED_MODULE_2__Mobile___default.a);
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "styleEditor"
  }, [_c('div', {
    staticClass: "code",
    domProps: {
      "innerHTML": _vm._s(_vm.codeInStyleTag)
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.highlightedCode)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "resumeEditor",
    class: {
      htmlMode: _vm.enableHtml
    }
  }, [(_vm.enableHtml) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.result)
    }
  }) : _c('pre', [_vm._v(_vm._s(_vm.result))])])
},staticRenderFns: []}

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('StyleEditor', {
    ref: "styleEditor",
    attrs: {
      "code": _vm.currentStyle
    }
  }), _vm._v(" "), _c('ResumeEditor', {
    ref: "resumeEditor",
    attrs: {
      "markdown": _vm.currentMarkdown,
      "enableHtml": _vm.enableHtml
    }
  })], 1)
},staticRenderFns: []}

/***/ })

},[50]);


// WEBPACK FOOTER //
// static/js/app.26c78396117dc712882a.js